var _Array$from = require("../core-js/array/from");

var _isIterable = require("../core-js/is-iterable");

function _iterableToArray(iter) {
  if (_isIterable(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return _Array$from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/iterableToArray.js
// module id = 468
// module chunks = 52252321336229